module.exports = __webpack_public_path__ + "media/images/competitions/brain-99fa18ceea8a4ad741df3f706def69e7.png";